import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import * as Menu from '../../components/menu/constants'
import * as Request from '../../request'
import {ApplicationState} from '../../rootReducer'
import * as Router from '../../router'
import * as Actions from './actions'
import * as Constants from './constants'

type OnEnter = ReduxObservable.Epic<Redux.Action, ApplicationState>
const onEnter: OnEnter = (action$, store, {history}) =>
  action$.ofType(Router.ON_ENTER)
    .filter(() => history.location.pathname.startsWith(Menu.ADMIN_IP_POOLS_URL))
    .mergeMap(() => [Actions.fetchPools(), Actions.fetchCommunities()])

type OnPut = ReduxObservable.Epic<Redux.Action, ApplicationState>
const onPut: OnPut = (action$, store, {history}) =>
  action$.ofType(Request.successConstant(Constants.POOL_CONFIG))
    .filter(() => history.location.pathname.startsWith(Menu.ADMIN_IP_POOLS_URL))
    .mergeMap(() => [Actions.fetchCommunities()])

export const epic = ReduxObservable.combineEpics(
    onEnter,
    onPut,
)



// WEBPACK FOOTER //
// ./src/pages/ip-pools/epic.ts